module.exports = __webpack_public_path__ + "img/horizontal_3_6_pp13_0.7423aa56.png";